'use client';

import { useState } from 'react';
import Image from "next/image";
import Link from "next/link";
import { Container, Grid, GridCol, Flex } from "@mantine/core";
import { Spotlight, spotlight } from '@mantine/spotlight';
import { Navigation } from '@components/Header/Navigation.jsx';
import { Cta } from '@components/Cta/Cta.jsx';
import { Icon } from "@components/Icon/Icon.jsx";
import classes from './Header.module.scss';

export function HeaderClient({ global }) {
    const [query, setQuery] = useState('');
    
    const actions = [
        {
            id: 'search',
            label: `Search ${query ? `for: "${query}"` : ''}`,
            description: 'See all results for this query',
            onClick: () => location.href = `/search?query=${query}`,
            leftSection: <Icon name="search" />,
            highlightColor: 'violet.2',
        },
    ];

    return (
        <>
            <Spotlight 
                actions={actions} 
                nothingFound="No results found" 
                highlightQuery 
                searchProps={{ rightSection: <Icon name="search" /> }} 
                query={query} 
                onQueryChange={setQuery} 
            />
            <header className={classes.mainHeader}>
                <Container size="lg">
                    <Grid align="center" className={classes.headerTop} pb={{base: 0, lg: 20}}>
                        <GridCol span={{ base: 2, lg: 3}}>
                            <a href="#content" className={classes.skipLink}>Skip to content</a>
                            <div className={classes.logo}>
                                <Link href="/" className={classes.logoImg}>
                                    <Image 
                                        src={`https:${global.fields.headerBrand.fields.file.url}`} 
                                        alt={global.fields.headerBrand.fields.title} 
                                        width={global.fields.headerBrand.fields.file.details.image.width} 
                                        height={global.fields.headerBrand.fields.file.details.image.height} 
                                    />
                                </Link>
                            </div>
                        </GridCol>
                        <GridCol span={{ base: 10, lg: 9}} className={classes.topNav}>
                            <Flex justify="flex-end" align="center" gap="md">
                                {global.fields.headerCta?.fields.url &&
                                    <div className={classes.desktopCta}>
                                        <Cta 
                                            url={`${global.fields.headerCta.fields.url}`} 
                                            title={global.fields.headerCta.fields.buttonText} 
                                            variant={global.fields.headerCta.fields.variant} 
                                            size={global.fields.headerCta.fields.size} 
                                            target={global.fields.headerCta.fields.target} 
                                        />
                                    </div>
                                }
                                <button 
                                    id="searchToggle" 
                                    type="button" 
                                    className={classes.searchToggle} 
                                    aria-label="Toggle search" 
                                    onClick={spotlight.open}
                                >
                                    <Icon name="search" />
                                </button>
                                <button 
                                    id="searchToggleMob" 
                                    type="button" 
                                    className={classes.searchToggleMob} 
                                    aria-label="Toggle search" 
                                    onClick={spotlight.open}
                                >
                                    <Icon name="search" />
                                </button>
                            </Flex>
                        </GridCol>
                    </Grid>
                    <Grid>
                        <GridCol span={12} className={classes.mainNav}>
                            <Navigation links={global.fields.mainNav} cta={global.fields.headerCta} />
                        </GridCol>
                    </Grid>
                </Container>
            </header>
        </>
    );
}
